import { render } from "./HeaderOrganism.vue?vue&type=template&id=49e797f2&scoped=true"
const script = {}

import "./HeaderOrganism.vue?vue&type=style&index=0&id=49e797f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e797f2"]])

export default __exports__